import React from "react";
import withStyles from "components/with-styles";
import styles from "./styles/dashboard-content.css.js";
import Banner from "../../banner/banner";
import {useCurrentCustomerContext} from "../../current-customer-context";
import {injectIntl} from "react-intl";

const DashboardContent = ({ classes, children, intl }) => {
    const { currentCustomerId, scopedViewByCustomer } = useCurrentCustomerContext();

    return (
        <main className={classes.dashboard_content}>
            {!currentCustomerId && scopedViewByCustomer && <Banner
                icon="warning"
                title={intl.formatMessage({id: "app.noCustomerErrorTitle"})}
                subtitle={intl.formatMessage({id: "app.noCustomerErrorSubtitle"})}
            />}
            {children}
        </main>
    )
};

export default injectIntl(withStyles(styles)(DashboardContent));
